import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-base"></i>
              </div>
              <span className="text-base font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫漫画网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费韩漫大全，好看的韩国漫画在线阅读平台。致力于为广大韩漫爱好者提供优质、便捷的阅读体验。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">分类浏览</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          {/* Popular Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">浪漫爱情</Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">奇幻玄幻</Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">动作冒险</Link>
              </li>
              <li>
                <Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">悬疑惊悚</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-400"></i>
                <span>contact@hanmancomic.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-foreground-400"></i>
                <span>微信公众号：韩漫漫画网</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-foreground-400"></i>
                <span>微博：@韩漫漫画网官方</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫漫画网 - 免费韩漫大全，好看韩国漫画在线阅读平台。本站所有漫画资源均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}